module.exports = __webpack_public_path__ + "static/media/header_1.fa124956.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_1.gif
// module id = 649
// module chunks = 0